import { useEffect } from 'react';
import { useContactsStore } from '@lib/store';
import { cn } from '@shared/utils';

interface ContactsProps {
  className?: string;
}

export const Contacts = (props: ContactsProps) => {
  const { data, getContacts } = useContactsStore();

  useEffect(() => {
    getContacts();
  }, []);

  return (
    <div className={cn('mt-12.5 min-h-[63px] text-center', props.className)}>
      {data?.Phone1 && (
        <p className='text-[#c4c4c4]'>
          International line: <span className='text-[#fff]'>{data.Phone1}</span>
        </p>
      )}
      {data?.Phone2 && (
        <p className='text-[#c4c4c4]'>
          UK toll free line: <span className='text-[#fff]'>{data.Phone2}</span>
        </p>
      )}
      {data?.Email && (
        <p className='text-[#c4c4c4]'>
          Email us:{' '}
          <a className='text-[#fff]' href={`mailto:${data.Email}`}>
            {data.Email}
          </a>
        </p>
      )}
    </div>
  );
};
